import React, { useEffect, useState } from 'react';
import profileIcon from '../Assets/images/profile-icon.svg'
import '../Assets/styles/newStyles/HomePage.css';
import Topbar from './Topbar';
// import Navbar from './Navbar';
import axios from '../axios';
import { BrowserRouter as Router, Route, Switch, useHistory } from 'react-router-dom';
// import Navbar from './Navbar';
import moment from 'moment';
import { NotificationManager } from 'react-notifications';
import { error } from 'jquery';

function HomePage() {
 const [assessmentsTab, setAssessmentsTab] = useState(false);
 const [breachesTab, setBreachesTab] = useState(true);
 const [data, setData] = useState([]);
 const [risk, setRisk] = useState();

  const assessmentsClicked = () => {
    setAssessmentsTab(true);
    setBreachesTab(false);
  }

  const breachesClicked = () => {
    setBreachesTab(true);
    setAssessmentsTab(false)
  }
  const history = useHistory();

  const handleCheckReport = (patientId, recordId) => {
    // Navigate to a new route using the recordId
    clearNotification(recordId);
    // Encode the patientId to handle special characters like slashes
    const encodedPatientId = encodeURIComponent(patientId);
    
    // Navigate to the new route
    history.push(`/patient/${localStorage.doctorId}/${encodedPatientId}`);
  };
  

  const clearNotification = async (recordId) => {
    try {
        const response = await axios.put(`/notifications`, null, {
            params: {
                recordId: recordId,
                userId: localStorage.doctorId,
                read: "True"
            }
        });
        // if (!response.data.message) {
        //     NotificationManager.error("Error", "Error occurred while clearing notification", 5000);
        // }
    } catch (error) {
        console.log(error, "Clear Notifications Error");
    }
  }

  useEffect(() => {
    getNotifications()
  },[]);

  const getNotifications = async () => {
    try {
      const response = await axios.get(`/notifications`, {
        headers: { accessToken: localStorage.accessToken },
        params: {
          userId: localStorage.doctorId
        },
      });
  
      const groupedByPatient = groupByPatient(response.data.data);
      const uniquePatientsWithLatestBreaches = findLatestBreaches(groupedByPatient);
      setData(uniquePatientsWithLatestBreaches);
    } catch(error){
      console.log("Error notifications", error);
    }
  }
  
  // Group breaches by patientId
  const groupByPatient = (breaches) => {
    const grouped = {};
    breaches.forEach(breach => {
      const patientId = breach.body.patientId;
      if (!grouped[patientId]) {
        grouped[patientId] = [];
      }
      grouped[patientId].push(breach);
    });
    return grouped;
  };
  
  // Find the latest breach for each patient
  const findLatestBreaches = (groupedBreaches) => {
    const latestBreaches = [];
    for (const patientId in groupedBreaches) {
      const breaches = groupedBreaches[patientId];
      const latestBreach = breaches.reduce((prev, current) => 
        moment(prev.body.timestamp) > moment(current.body.timestamp) ? prev : current
      );
      if (latestBreach.read !== "true") {
        latestBreaches.push(latestBreach);
      }
    }
    return latestBreaches;
  };

  // const getNotifications = async () => {
  //   try {
  //     const response = await axios.get(`/notifications`, {
  //       headers: { accessToken: localStorage.accessToken },
  //       params: {
  //         userId: localStorage.doctorId
  //       },
  //     });
  //     // console.log(response.data.data);
  //     // setData(response.data.data)
  //     const dataObject = {};
  //       const idOccurrences = {};
  //       response.data.data.forEach(item => {
  //           const id = item.id;
  //           idOccurrences[id] = (idOccurrences[id] || 0) + 1;
  //       });

  //       response.data.data.forEach(item => {
  //           const id = item.id;
  //           if (idOccurrences[id] === 1) {
  //               dataObject[id] = item;
  //           } else {
  //               if (!dataObject[id] || dataObject[id].body.timestamp > item.body.timestamp) {
  //                   dataObject[id] = item;
  //               }
  //           }
  //       }); 
  //       // Convert back to array
  //       const filteredData = Object.values(dataObject);
  //       setData(filteredData);
  //   }catch(error){
  //     console.log("Error notifications", error);
  //   }
  // }

  return (
    <>
      {/* <Navbar /> */}
      <div className='home-main-container'>
        <div className='home-sub-container'>
        {/* <Topbar /> */}
          <h1 className='home-main-heading'>Alerts</h1>
          <div className='home-alerts-container'>
            <div className='home-sub-headings-container'>
              {/* <h2 className= 'home-sub-headings' onClick={assessmentsClicked}>Assessments</h2> */}
              <h2 className='home-sub-headings' onClick={breachesClicked}>Breaches</h2>
            </div>
            {/* <div className="assessments-vector"></div> */}
            {assessmentsTab && 
              <>
                <div className="assessments-vector"></div>
                <div className='home-assessments-container'>
                  <div className='assessments-breaches-card'>
                    <img className='assessments-card-img' src={profileIcon} alt="" />
                    <div className='assessments-cards'>
                      <div className='assessments-card-container'>
                        <p className='assessments-card-name'>Vijay Sharma</p>
                        <div className='assessments-risk-container'>
                          <span className='circle-high'>
                            •
                            <span class="text-style-1"></span>
                          </span>
                          <p className='high-risk-text'>High Risk</p>
                        </div>
                      </div>
                      <div className='assessments-card-container'>
                        <p className='assessment-id'>#124356</p>
                        <p className='assessment-type'>Asthma</p>
                      </div>
                      <div className='assessments-card-container'>
                        <p className='assessment-type'>1 hour ago</p>
                        <button className='assessments-report-button'>
                          Check Report
                        </button>
                      </div>
                    </div>
                  </div>
                </div> 
              </> 
            }
            {breachesTab && <div className="assessments-vector"></div>}
            {breachesTab && Array.isArray(data) && data.length > 0 ? (
              data.every(obj => obj.read === true) ? (
                <div  className='no-breaches-container'>
                  {/* <div className='assessments-card'> */}
                    <p className='no-breaches-text'>No breaches pending for review</p>
                  {/* </div> */}
                </div>
              ) : (
                data.map((obj, index) => (
                  !obj.read && (
                    <div key={index} className='home-assessments-container'>
                      <div className='assessments-breaches-card'>
                        <img className='assessments-card-img' src={profileIcon} alt="" />
                        <div className='assessments-cards'>
                          <div className='assessments-card-container'>
                            <p className='assessments-card-name'>{obj?.body?.firstname}</p>
                            <div className='assessments-risk-container'>
                              {obj?.body?.lung_health_index === 'Low' && (
                                <span className='circle-low'>
                                  •
                                  <span className="text-style-1"></span>
                                </span>
                              )}
                              {obj?.body?.lung_health_index === 'Medium' && (
                                <span className='circle-medium'>
                                  •
                                  <span className="text-style-1"></span>
                                </span>
                              )}
                              {obj?.body?.lung_health_index === 'High' && (
                                <span className='circle-high'>
                                  •
                                  <span className="text-style-1"></span>
                                </span>
                              )}
                              <p className={obj?.body?.lung_health_index === 'Low' ? 'low-risk-text' : (obj.body.lung_health_index === 'Medium' ? 'medium-risk-text' : 'high-risk-text')}>
                                {obj.body.lung_health_index === 'low' ? 'Low Risk' : (obj.body.lung_health_index === 'medium' ? 'Medium Risk' : 'High Risk')}
                              </p>
                            </div>
                          </div>
                          <div className='assessments-card-container'>
                            <p className='assessment-id'>{obj.body.patientId}</p>
                          </div>
                          {/* <p className='assessment-type'>{obj.type}</p> */}
                          <div className='assessments-card-container'>
                            {/* <p className='assessment-time'>{moment(obj.body.timestamp)}</p> */}
                            <button className='assessments-report-button' 
                              onClick={() => handleCheckReport(obj.body.patientId, obj.body.recordId)} 
                            >
                              Check Report
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                ))
              )
            ) : (
              <div className='assessments-cards'>
                {/* <p className='no-breaches-text'>{breachesTab ? "No breaches pending for review" : "No data available"}</p> */}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default HomePage;
